import { render, staticRenderFns } from "./Autoroles.vue?vue&type=template&id=3131e7fd"
import script from "./Autoroles.vue?vue&type=script&lang=js"
export * from "./Autoroles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports